import { styled } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

export const CustomAlert = styled(Alert)(() => ({
  width: 'max-content',
  maxHeight: 50,
}));
